import useSearchFiltersFormActions from 'search-filter/hooks/useSearchFiltersFormActions';

const SearchFilterActionsProvider = {
  key: 'searchFilters',
  // eslint-disable-next-line react-hooks/rules-of-hooks
  provider: () => useSearchFiltersFormActions(),
};

export default SearchFilterActionsProvider;
